import { render, staticRenderFns } from "./BsButton.vue?vue&type=template&id=712759dd&scoped=true&"
import script from "./BsButton.vue?vue&type=script&lang=js&"
export * from "./BsButton.vue?vue&type=script&lang=js&"
import style0 from "./BsButton.vue?vue&type=style&index=0&id=712759dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712759dd",
  null
  
)

export default component.exports